import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { SaleType, SaleTypeRestorePayload } from './models';

const saleTypeService = {
  getAll(showFlg: number): Promise<CommonResponse<SaleType[]>> {
    const url = `/saletypes?show_flg=${showFlg}`;
    return axiosClient.get(url);
  },
  delete(params: { ids: number[] }): Promise<CommonResponse<null>> {
    const url = '/saletypes';
    return axiosClient.delete(url, { data: params });
  },
  add(param: SaleType): Promise<CommonResponse<null>> {
    const url = '/saletypes';
    return axiosClient.post(url, param);
  },
  update(param: SaleType): Promise<CommonResponse<null>> {
    const url = '/saletype/' + param.id;
    return axiosClient.patch(url, param);
  },
  restore(payload: SaleTypeRestorePayload): Promise<CommonResponse<any>> {
    const url = `/saletypes/restore`;
    return axiosClient.patch(url, payload);
  },
};

export default saleTypeService;
